export default class GenericMapControl {
    constructor( options ){
        this.options = {};
        this.options.className = options && options.className || '';
    }


    onAdd () {
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl ' + this.options.className;

        this._container.innerHTML = '';

        return this._container;

    }
    getContainer () {
        return this._container;
    }

    onRemove () {
        this._container.parentNode.removeChild(this._container);
    }

    getDefaultPosition () {
        return 'top-right';
    }
}


// WEBPACK FOOTER //
// src/kiosk/GenericMapControl/index.js